const $ = require('jquery');
const _ = require("underscore");
import {setElementsFromScope} from "../../utilities/selectorHelpers";
import {bindJumpToWizardLinks} from '../../utilities/jumpToWizardLogic';
import run from '../../utilities/run';
import detailAddressValidation from './detailAddressValidation.js';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT,SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";
import render from '../../utilities/render';
import {buildExport,doAjax} from "../../utilities/filtersutil";
import {isPresent} from "../../utilities/general";
import PagableComponent from '../../components/pagableComponent/index';


const serviceLookupBody = require('./detailPageLookupHTML/serviceLookupBody.html');
const serviceLookupMultiRowsColumns = require('./detailPageLookupHTML/serviceLookupMultiRowsColumns.html');
const packageLookupItem = require('./detailPageLookupHTML/packageLookupItem.html');
const packageLookupBody  = require('./detailPageLookupHTML/packageLookupBody.html');
const productLookupBody = require('./detailPageLookupHTML/productLookupBody.html');
const modalBodyForPackingDetailHtml = require('./detailPageLookupHTML/modalBodyForPackingDetail.html');
const modalFooterForPackingDetailHtml = require('./detailPageLookupHTML/modalFooterForPackingDetail.html');
const renderTemplateForPackingSubRowHtml  = require("./detailPageLookupHTML/renderTemplateForPackingSubRow.html");
const modalHtml = require("../../sharedHtml/modal.html");
const loaderHtml = require("../../sharedHtml/loaderOverlay.html");
require("./asnDetail.less");

run("#asn-detail-page", ()=>{
  const el = $("#asn-detail-page");
  asnDetail(el);
});

function asnDetail(el){
  
  const isShipmentChange = el.data("shipment-info-change-flag");
  const understandBtnUrl = el.data("understand-btn-url");
  const asn = el.data("asn");
  const asnPortletEditPerm = el.data("asn-edit-param");
  const shouldCheckCache = el.data("should-check-cache");
  const canEditGtlAsn = el.data("canEditGtlAsn");
  const editAsnUrl = el.data("edit-asn-url");
  const namespace = el.data("namespace");
  const generalErrorMessage = el.data("general-error-message");
  const cancelAsnUrl = el.data("cancel-asn-url");
  const viewAsnUrl = el.data("view-asn-url");
  const cancelConfirmMsg1 = el.data("cancel-confirm-msg1");
  const cancelConfirmMsg2 = el.data("cancel-confirm-msg2");
  const cancelErrorMsg1 = el.data("cancel-error-msg1");
  const cancelErrorMsg2 = el.data("cancel-error-msg2");
  const generateAsnLabelsUrl = el.data("asn-label-url");
  const isPallet = el.data("is-pallet");  
  const generateFedExShippingLabelsUrl = el.data("asn-fedex-shipping-label-url");
  const generateBOLLabelUrl = el.data("asn-bol-label-url");
  const els = {};
  const initialDataForServicesLookup = el.data("initial-data-for-services-lookup");
  const asnDetailProductLookupURL = el.data("asn-detail-product-lookup-url");
  const asnDetailPackingLookupURL = el.data("asn-detail-packing-lookup-url");
  const asnDetailServiceLookupURL = el.data("asn-detail-service-lookup-url");
  const getPackageProductsURL = el.data("get-package-products-url");

  
  const portletNamespace =  el.data("portlet-namespace");
  const pageSizeOptionsArray = [10,25,50,100];
  const items = el.data("items");
  const services = el.data("services");
  const packages = el.data("packages");
  const asnShippingPallets = asn.asnShippingPallets;
  let checkIfAsnShippingPalletsExists = false;
  
  bindJumpToWizardLinks();
  
  const elementsMap = {
    destinationSectionPencil: ".destination-section-pecil",
    contentSectionPencil: ".contents-section-pencil",
    servicesSectionPencil: ".services-section-pencil",
    shippingSectionPencil: ".shipping-section-pencil",
    packingSectionPencil: ".packing-section-pencil",
    cancelShipmentBtn: "#asn-detail-cancel-shipment",
    editShipmentBtn: "#asn-detail-edit-shipment",
    pencilIcon: ".fa-pencil",
    returnToShipmentsBtn: "#asn-detail-return-to-shipments",
    printLabelsBtn: "#asn-detail-print-labels",
    printFedExLabelsBtn:  "#asn-detail-print-fedex-label",
    printBolBtn: "#asn-detail-print-bol",
    asnServiceLookupPagingArea: "#asn-detail-service-paging-area",
    asnServiceLookupMainArea: "#asn-detail-service-main-area tbody",
    asnPackingLookupPagingArea: "#asn-detail-packing-paging-area",
    asnPackingLookupMainArea: "#asn-detail-packing-main-area",
    asnProductLookupMainArea :"#asn-detail-product-main-area",
    asnProductLookupPagingArea :"#asn-detail-product-paging-area"
  };
  
  const submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();

  // elements at document scope
  const docElementsMap = {
    errorModal: "#errorModal",
    confirmationModal: "#confirmationModal",
    cancelModal: "#cancelModal",
    shippingChangeModal: "#fedex-shipment-change",
    iUnderstandBtn: ".understand-btn",
    modalCancelAsnBtn: "#modalCancelAsn"
  };

  setElements();
  onLoad();

  function setElements() {
    setElementsFromScope(els, elementsMap, el);
    setElementsFromScope(els, docElementsMap, $(document));
  }

  function onLoad() {

    const asnStatus = asn.asnStatus;
    const asnShippingPartner = asn.asnShippingPartner;

    if(isPresent(asnShippingPallets) && asnShippingPallets.length >0){
      checkIfAsnShippingPalletsExists = true;
    }

    if(asn.asnType === "R" && asnPortletEditPerm === true) {
      if(canEditGtlAsn === true) {
        showCancelShipmentBtn();
      }
    } else if(asnPortletEditPerm === true) {
      showEditShipmentBtn();
      if(canEditGtlAsn === true) {
        showCancelShipmentBtn();
      }
      els.destinationSectionPencil.show();
      els.contentSectionPencil.show();
      els.servicesSectionPencil.show();
      els.shippingSectionPencil.show();
      els.packingSectionPencil.show();
    }
    if(asnStatus === "In Transit"){
      hideEditShipmentBtn();
      els.destinationSectionPencil.hide();
      els.contentSectionPencil.hide();
      els.servicesSectionPencil.hide();
      els.shippingSectionPencil.hide(); 
      els.packingSectionPencil.hide();
    }

    if(asnStatus === "Canceled" || asnStatus === "Complete" 
              || asnStatus === "Receiving") {
      hideCancelShipmentBtn();
      hideEditShipmentBtn();
      els.destinationSectionPencil.hide();
      els.contentSectionPencil.hide();
      els.servicesSectionPencil.hide();
      els.shippingSectionPencil.hide(); 
      els.packingSectionPencil.hide();     
    }

    if(isShipmentChange === true) {
      els.shippingChangeModal.modal("show");
    }

    //### Common method for lookup of detail page ####//


    function prepareDataToSendController(page, pageSize,portletNamespace){ 
      portletNamespace = isPresent(portletNamespace) ? portletNamespace : "";
      let data = {    
        [`${portletNamespace}pageSize`] : pageSize,
        [`${portletNamespace}page`] : page,
      }
      return data;
    }


    const serviceTotalCount =   services.totalElements;
    const pacakgeTotalCount =   packages.totalElements;
    const productTotalCount =   items.totalElements;
    let packagePrductCount;

    // ########## Services lookup screen start ########## /
    const serviceLookup = new PagableComponent({
      dataContainer: els.asnServiceLookupMainArea, // area in example.html where data rows will go.
      pagingContainer: els.asnServiceLookupPagingArea, // area in example.html where paging tab will go.
      pageSizeOptions: pageSizeOptionsArray, // optional default:[10,25,50,100].
      pageSize: 10, // optional default: 10.
      data: services,
      showData: function(row){
        return render(serviceLookupBody, {
          sku: row.sku,
          service: renderService(row.service),
          quantity: row.quantity,
          cost: renderCost(row.service)
        });
      },
    // onFetch function from line 70 to 78 is strictly for example only and should not be used anywhere. For real world scenario just pass response data to pagable.setData()
      onFetch: function(page, pageSize){
        serviceLookup.showLoadingOverlay();
        setTimeout(() => {
          doAjax({url: asnDetailServiceLookupURL, success: serviceLookupSuccess, error: errorFun,data:prepareDataToSendController(page, pageSize,portletNamespace)});
        },SUCCESS_MODAL_TIMEOUT);
       // serviceLookup.setData(tempData);
      }
    });

    serviceLookup.init();
    

     function renderService(service) {
      let temp = "";
       _(service).map((item) => {
        let service = render(serviceLookupMultiRowsColumns, {  value : item.serviceName });
        temp = temp + service;
      });
       return temp;
     }

    function renderCost(service) {
      let temp = "";
      _(service).map((item) => {
        let cost = render(serviceLookupMultiRowsColumns, {value : item.estimatedCost});
          temp = temp + cost;
      });
      return temp;
    }

    

    function serviceLookupSuccess(data){ 
      let asn = data.content;
      serviceLookup.setData(asn);
      serviceLookup.hideLoadingOverlay();
    }

    function errorFun(data){
     serviceLookup.hideLoadingOverlay();
    }

    // ############### Services lookup screen END ################## //


    // ############### Packing lookup screen START ################## //
      const packingLookup = new PagableComponent({
      dataContainer: els.asnPackingLookupMainArea, // area in example.html where data rows will go.
      pagingContainer: els.asnPackingLookupPagingArea, // area in example.html where paging tab will go.
      pageSizeOptions: pageSizeOptionsArray, // optional default:[10,25,50,100].
      pageSize: 10, // optional default: 10.
      data: packages,
      showData: function(row){
      return render(packageLookupBody, {
        packageName : row.packageName,
        noOfPackages: row.noOfPackages ,
        dimensions : row.dimensions,
        weight : row.weight,
        lpns : row.lpns,
        isPallet : isPallet,
        isCustomCaseId : row.isCustomCaseId,
        shippingPartner : asnShippingPartner,
		dvlCalculatedValue : row.dvlCalculatedValue,
        checkIfAsnShippingPalletsExists : checkIfAsnShippingPalletsExists
      });
      },
      // onFetch function from line 42 to 50 is strictly for example only and should not be used anywhere. For real world scenario just pass response data to pagable.setData(). Line 51 to 54 needs to be there to add loading overlay effect to any page change and per page select change.
      onFetch: function(page, pageSize){
        packingLookup.showLoadingOverlay();
        setTimeout(() => {
          doAjax({url: asnDetailPackingLookupURL, success: packingLookupSuccess, error: errorFun,data:prepareDataToSendController(page, pageSize,portletNamespace)});
        },SUCCESS_MODAL_TIMEOUT);
      } 

    });

    packingLookup.init();

    function packingLookupSuccess(data){ 
      let asn = data.content;
     // let page = data.page;
      packingLookup.setData(asn);
      packingLookup.hideLoadingOverlay();
    }

    function errorFun(data){
      packingLookup.hideLoadingOverlay();
    }


    function preparePackageProducts(page, pageSize,portletNamespace,packageName){ 
      portletNamespace = isPresent(portletNamespace) ? portletNamespace : "";
      let data = {    
        [`${portletNamespace}pageSize`] : pageSize,
        [`${portletNamespace}page`] : page,
        [`${portletNamespace}packageName`] : packageName
      }
      return data;
    }



    function renderProducList(product) {
      let productList = _(product).map((item) => {
        let productItem = render(
          packageLookupItem, {
            sku : item.sku,
            isPallet :  isPallet,
            prdName : item.prdName,
            unitspercase :  item.unitspercase,
            totalUnits :  item.totalUnits,
            expirationDate : item.expirationDate,
            lotNumber : item.lotNumber
          }
        );
        return productItem;
      });
      return productList;
  }


    $('.packing').on('click', '.view-detail-btn-for-packing', function(e) {
      e.preventDefault();
      packingLookup.showLoadingOverlay();
      const packageName = $(this).data('pallet-num');
      setTimeout(() => {
        doAjax({url: getPackageProductsURL, success: getPackageProductsSuccess, error: updatePackageProductsErrorFun(packingLookup),data:preparePackageProducts(0, 10,portletNamespace,packageName)});
      },SUCCESS_MODAL_TIMEOUT);
     
      const modalForPackingDetail = $(render(
        modalHtml,
        {
          modalDialogClass: 'q-modal-dialog-800',
          title: `${packageName}`,
          topCloseBtn: true,
          autoHideTop: true,
          leftAlignTitle: true,
          body: renderModalBody(),
          footerBtns: modalFooterForPackingDetailHtml
        }
     ));
      
      function renderModalBody(){
         return render( modalBodyForPackingDetailHtml , {
            isPallet: isPallet,
            lpns : getLpns()
          });
      }
      
      function getLpns(){
        let searchQuery = {"packageName" : packageName , "isCustomCaseId": true};
        let searchObj = _.where(packages.content, searchQuery)[0];
        let returnVal = "";
        if(isPresent(searchObj)){
          returnVal = searchObj.lpns
        }
        return returnVal;
      }




     let pagablePackingRow;
     function getPackageProductsSuccess(data){
        packagePrductCount = data.totalElements;
        $('body').append(modalForPackingDetail);
        modalForPackingDetail.modal("show");
        modalForPackingDetail.on('hidden.bs.modal', function (e) {
          modalForPackingDetail.remove();
        });
        packingLookup.hideLoadingOverlay();
        setPackingProductExportData(currentData,packageName);  
        pagablePackingRow =  new PagableComponent({
        dataContainer: '.main-area-for-sub-row',
        pagingContainer: '.paging-area-for-sub-row',
        pageSizeOptions: pageSizeOptionsArray,
        pageSize: 10,
        data: data,
        showData: function(row){
          return render(renderTemplateForPackingSubRowHtml, {
            productName: row.sku,
            description: row.prdName,
            unitsInPallet: row.sentUnits,
            totalUnits: row.totalUnits
          });
        },
        onFetch: function(page, pageSize){
            pagablePackingRow.showLoadingOverlay();
            setTimeout(() => {
              doAjax({url: getPackageProductsURL, success: updatePackageProducts, error: updatePackageProductsErrorFun(pagablePackingRow),data:preparePackageProducts(page, pageSize,portletNamespace,packageName)});
            },SUCCESS_MODAL_TIMEOUT);  
        }
      });
        pagablePackingRow.init();
      }

      function updatePackageProducts(data){
          pagablePackingRow.setData(data.content);
          pagablePackingRow.hideLoadingOverlay();
      }

      function updatePackageProductsErrorFun(componentEle){
        componentEle.hideLoadingOverlay();
      }
    });
  // ############### Packing lookup screen END ################## //

  // ############### Product lookup screen START ################## //
    const productLookup = new PagableComponent({
      dataContainer: els.asnProductLookupMainArea, // area in example.html where data rows will go.
      pagingContainer: els.asnProductLookupPagingArea, // area in example.html where paging tab will go.
      pageSizeOptions: pageSizeOptionsArray, // optional default:[10,25,50,100].
      pageSize: 10, // optional default: 10.
      data: items,
      showData: function(row){
        return render(productLookupBody, {
          sku : row.sku,
          noOfPackages: row.noOfPackages ,
          sentUnits : row.sentUnits,
          prdName : row.prdName,
          receivedUnits : row.receivedUnits,
          upc : row.upc,
          prdDesc : row.prdDesc
        });
      },
      onFetch: function(page, pageSize){
        productLookup.showLoadingOverlay();
        setTimeout(() => {
          doAjax({url: asnDetailProductLookupURL, success: productLookupSuccess, error: errorFun,data:prepareDataToSendController(page, pageSize, portletNamespace)});
        },SUCCESS_MODAL_TIMEOUT);
      } 

    });

    productLookup.init();

    function productLookupSuccess(data){ 
      let asn = data.content;
      //let page = data.page;
      productLookup.setData(asn);
      productLookup.hideLoadingOverlay();
    }

    function errorFun(data){
      productLookup.hideLoadingOverlay();
    }

    // ############### Product lookup screen END ################## //

    let productExportModal = new buildExport(); 
    let packingExportModal = new buildExport(); 
    let serviceExportModal = new buildExport(); 
    let packingProductExportModal = new buildExport(); 

    function initPackingProductExport() {
      const cssClassNameForExportButtonOnPage = "packingPrdExportDataModal";
      const cssClassNameForExportButtonOnPopup = "packingPrdExportBtn";
      const cssClassNameForSelectFileTypeOnPopup  = "packingPrdFileTypeClass";
      const cssClassNameForCount = "packingPrdExportCountCSS";

      let exportObj  =  {
        title : "Products", 
        exportAttemptTextPart1Lang: el.data("export-attempt-text-part1"), 
        exportAttemptTextPart2Lang: el.data("export-attempt-text-part2"),
        exportMaxLimitLang: el.data("export-max-row-limit"),
        cssClassNameForExportButtonOnPage: cssClassNameForExportButtonOnPage,
        cssClassNameForExportButtonOnPopup : cssClassNameForExportButtonOnPopup,
        cssClassNameForSelectFileTypeOnPopup : cssClassNameForSelectFileTypeOnPopup,
        cssClassNameForCount:cssClassNameForCount
      }; 
      packingProductExportModal.init(exportObj);
      packingProductExportModal.bindExportEvent(portletNamespace,cssClassNameForExportButtonOnPopup,cssClassNameForSelectFileTypeOnPopup);
    }


    function initPackingExport() {
      const cssClassNameForExportButtonOnPage = "packingExportDataModal";
      const cssClassNameForExportButtonOnPopup = "packingExportBtn";
      const cssClassNameForSelectFileTypeOnPopup = "packingFileTypeClass";
      const cssClassNameForCount = "packingExportCountCSS";

      let exportObj  =  {
        title :"Packing", 
        exportAttemptTextPart1Lang: el.data("export-attempt-text-part1"), 
        exportAttemptTextPart2Lang: el.data("export-attempt-text-part2"),
        exportMaxLimitLang: el.data("export-max-row-limit"),
        cssClassNameForExportButtonOnPage: cssClassNameForExportButtonOnPage,
        cssClassNameForExportButtonOnPopup : cssClassNameForExportButtonOnPopup,
        cssClassNameForSelectFileTypeOnPopup : cssClassNameForSelectFileTypeOnPopup,
        cssClassNameForCount:cssClassNameForCount
      }; 
      packingExportModal.init(exportObj);
      packingExportModal.bindExportEvent(portletNamespace,cssClassNameForExportButtonOnPopup,cssClassNameForSelectFileTypeOnPopup);
    }

    function initProductExport() {
      const cssClassNameForExportButtonOnPage = "productExportDataModal";
      const cssClassNameForExportButtonOnPopup = "productExportBtn";
      const cssClassNameForSelectFileTypeOnPopup = "productFileTypeClass";
      const cssClassNameForCount = "productExportCountCSS";
      let exportObj  =  {
        title : "Products", 
        exportAttemptTextPart1Lang: el.data("export-attempt-text-part1"), 
        exportAttemptTextPart2Lang: el.data("export-attempt-text-part2"),
        exportMaxLimitLang: el.data("export-max-row-limit"),
        cssClassNameForExportButtonOnPage: cssClassNameForExportButtonOnPage,
        cssClassNameForExportButtonOnPopup : cssClassNameForExportButtonOnPopup,
        cssClassNameForSelectFileTypeOnPopup : cssClassNameForSelectFileTypeOnPopup,
        cssClassNameForCount:cssClassNameForCount
      }; 
      productExportModal.init(exportObj);
      productExportModal.bindExportEvent(portletNamespace,cssClassNameForExportButtonOnPopup,cssClassNameForSelectFileTypeOnPopup);
    }

    function initServiceExport() {
      const cssClassNameForExportButtonOnPage = "serviceExportDataModal";
      const cssClassNameForExportButtonOnPopup = "serviceExportBtn";
      const cssClassNameForSelectFileTypeOnPopup = "serviceFileTypeClass";
      const cssClassNameForCount = "serviceExportCountCSS";
      let exportObj  =  {
        title : "Services", 
        exportAttemptTextPart1Lang: el.data("export-attempt-text-part1"), 
        exportAttemptTextPart2Lang: el.data("export-attempt-text-part2"),
        exportMaxLimitLang: el.data("export-max-row-limit"),
        cssClassNameForExportButtonOnPage: cssClassNameForExportButtonOnPage,
        cssClassNameForExportButtonOnPopup : cssClassNameForExportButtonOnPopup,
        cssClassNameForSelectFileTypeOnPopup : cssClassNameForSelectFileTypeOnPopup,
        cssClassNameForCount:cssClassNameForCount
      }; 
      serviceExportModal.init(exportObj);
      serviceExportModal.bindExportEvent(portletNamespace,cssClassNameForExportButtonOnPopup,cssClassNameForSelectFileTypeOnPopup);
    }

    const productExportURL = el.data("product-export-url");
    const serviceExportURL = el.data("service-export-url");
    const packingExportURL = el.data("packing-export-url");
    const packingProductExportURL = el.data("packing-product-export-url");

    function setPackingProductExportData(currentData,packageName) {
      packingProductExportModal.buildExportBasicURL(packingProductExportURL,currentData);
      let url = packingProductExportModal.getCurrentUrl();
      url =  url + [`&${portletNamespace}asnShipmentId=`]+asn.asnShipmentId+[`&${portletNamespace}packageName=`]+packageName+[`&${portletNamespace}isPallet=`]+isPallet;
      packingProductExportModal.buildExportBasicURL(url,currentData,portletNamespace);
      packingExportModal.setExportCount(packagePrductCount,"packingPrdExportCountCSS");
    }

    function setPackingExportData(currentData) {
      packingExportModal.buildExportBasicURL(packingExportURL,currentData);
      let url = packingExportModal.getCurrentUrl();
      url =  url + [`&${portletNamespace}asnShipmentId=`]+asn.asnShipmentId;
      packingExportModal.buildExportBasicURL(url,currentData,portletNamespace);
      packingExportModal.setExportCount(pacakgeTotalCount,"packingExportCountCSS");
    }

   function setProductExportData(currentData) {
      productExportModal.buildExportBasicURL(productExportURL,currentData);
      let url = productExportModal.getCurrentUrl();
      url =  url + [`&${portletNamespace}asnShipmentId=`]+asn.asnShipmentId;
      productExportModal.buildExportBasicURL(url,currentData,portletNamespace);
      productExportModal.setExportCount(productTotalCount,"productExportCountCSS");
    }

    function setServiceExportData(currentData) {
      serviceExportModal.buildExportBasicURL(serviceExportURL,currentData);
      let url = serviceExportModal.getCurrentUrl();
      url =  url + [`&${portletNamespace}asnShipmentId=`]+asn.asnShipmentId;
      serviceExportModal.buildExportBasicURL(url,currentData,portletNamespace);
      serviceExportModal.setExportCount(serviceTotalCount,"serviceExportCountCSS");
    }

    let currentData = {};
    initPackingExport();
    setPackingExportData(currentData);

    initServiceExport();
    setServiceExportData(currentData);

    initProductExport();
    setProductExportData(currentData);  

    initPackingProductExport();

}

  els.iUnderstandBtn.click(function () {
    location.href = understandBtnUrl;
  });

  function showCancelShipmentBtn() {
    els.cancelShipmentBtn.show();
  }

  function showEditShipmentBtn() {
    els.editShipmentBtn.show();
  }

  function hideCancelShipmentBtn() {
    els.cancelShipmentBtn.hide();
  }

  function hideEditShipmentBtn() {
    els.editShipmentBtn.hide();
  }

  els.editShipmentBtn.click(function () {
    editAsn();
  });

  els.pencilIcon.on('click', function () {
    editAsn();
  });

  els.returnToShipmentsBtn.click(function (){
    if(shouldCheckCache === true) {
      window.history.go(-1); 
      return false;
    } else {
      location.href = viewAsnUrl;
    }
  });

  function editAsn() {
    location.href = `${editAsnUrl}`;
  }

  els.cancelShipmentBtn.on("click", function () {
    els.cancelModal.modal("show");
  });

  els.modalCancelAsnBtn.click(function (){
    cancelAsn();
  });

  function cancelAsn() {
  submitModalFlow.showLoadingModal();  
    $.ajax({
      url: cancelAsnUrl,
      type: "POST",
      data: {
        [`${namespace}asnId`]: asn.asnId
      },
      success: onCancelSuccess,
      error: onCancelError
    });
  }

  function onCancelSuccess(data) {
    if(data.match("success")) {
    submitModalFlow.showSuccessModal();
    setTimeout(function() { 
      location.reload();
    }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
    } else if(data.match("Receiving") || data.match("Complete")) {
      $("#modalTextLine1").html(`${cancelErrorMsg1} <b class="text-info"> ${_.escape(asn.asnShipmentId)} </b> ${cancelErrorMsg2}`);
      els.errorModal.modal("show");
    } else {
      alert(generalErrorMessage);
    }
  }

  function onCancelError(data) {
    alert(generalErrorMessage);
  }

  els.printLabelsBtn.click(function () {
    window.open(`${generateAsnLabelsUrl}&${namespace}fileName=packages.pdf`,'window1');
  });

  els.printFedExLabelsBtn.click(function () {
    let fedexShippingLables = window.open(`${generateFedExShippingLabelsUrl}&${namespace}fileName=fedexShippingLables.pdf`,'fedexShippingLables');
    fedexShippingLables.document.title = 'FedEx Shipping Labels';
  });

  els.printBolBtn.click(function () {
    let bolWindow = window.open(`${generateBOLLabelUrl}&${namespace}fileName=bol.pdf`,'bolWindow');
    bolWindow.document.title = 'Bill of Lading (BOL)';
  });

}


// WEBPACK FOOTER //
// ./src/pages/asns/details.js